interface IntegrationSettingsErrorProps {
  errorMessage: string;
}

export default function IntegrationSettingsError({
  errorMessage,
}: IntegrationSettingsErrorProps) {
  return (
    <p className="text-red-500 text-sm">
      There was an error loading the integration settings: {errorMessage}.
      Please remove the integration and add it again. If the problem persists
      contact support
    </p>
  );
}
